<template>
  <div>
    <v-row justify="space-around">
      <v-col cols="6">
        <v-card style="background-color: white" elevation="1">
          <p
            style="
              font-weight: bold;
              text-align: center;
              margin-bottom: 0;
              font-size: large;
            "
          >
            Branch
          </p>
          <!-- <ChartDoughnutBase :chartData="chartData" :options="options" /> -->
          <C3Chart :chartData="chartData2" v-if="chartData2"></C3Chart>
        </v-card>
      </v-col>
      <v-col cols="6">
         <v-card style="background-color: white" elevation="1">
          <p
            style="
              font-weight: bold;
              text-align: center;
              margin-bottom: 0;
              font-size: large;
            "
          >
            Service
          </p>
          <!-- <ChartDoughnutBaseB :chartData="chartData1" :options="options" /> -->
            <C3Chart :chartData="chartData3" v-if="chartData3"></C3Chart>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import ChartDoughnutBase from './ChartDoughnutUseActivityBase'
import ChartDoughnutBaseB from './ChartDouhdonutUseActivityBaseB'
import axios from 'axios'
import Card from '../Master/Card.vue'
import C3Chart from '../../components/c3.vue'

export default {
  name: 'ChartMemberUseActivity',
  components: {
    ChartDoughnutBase,
    ChartDoughnutBaseB,
    Card,
    C3Chart
  },
  props: ['activityId', 'dialog'],
  data () {
    return {
      chartData2: null,
      chartData3: null,
      form: [],
      memberS: [],
      service: [],
      memberB: [],
      branch: [],
      options: {
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              console.log(ctx.dataset._meta)
              for (var key in ctx.dataset._meta) {
                var total = ctx.dataset._meta[key].total
                console.log(key)
              }
              let percentage = ((value * 100) / total).toFixed(0) + '%'
              return percentage
            },
            color: '#fff'
          }
        }
      }
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    await this.getApi()
    // this.ChartC3()
  },
  methods: {
    async ChartC3 () {
      console.log('test')
      this.chartData2 = {
        data: {
          columns: [
            ['null', 1],
            ['สาขาหนองเเขม', 1]
          ],
          type: 'donut'
        },
        donut: {
          title: 'สาขา'
        }
      }
      this.chartData3 = {
        data: {
          columns: this.columns1,
          type: 'donut'
        },
        donut: {
          title: 'ประเภทบริการ'
        }
      }
    },
    async getApi () {
      console.log('getApi', this.activityId)
      await axios
        .get(
          this.DNS_IP +
          '/last-member-use-activity/' +
          'get?activityId=' +
          this.activityId + '&shopId=' + this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          this.form = response.data
          console.log('11123', this.form)
          this.form.map((item, i) => {
            item.service === null ? item.service = 'ไม่มีข้อมูล' : item.service = item.service
            item.branchName === null ? item.branchName = 'ไม่มีข้อมูล' : item.branchName = item.branchName
          })
          console.log('11123444', this.form)

          let columns1 = []
          let columns2 = []
          this.memberS = this.form.map((item) => item.MemberJoinS)
          this.service = this.form.map((item) => item.service)
          this.memberB = this.form.map((item) => item.MEmberJoinB)
          this.branch = this.form.map((item) => item.branchName)
          for (let i = 0; i < this.service.length; i++) {
            columns1[i] = [`${this.service[i]}`, this.memberS[i]]
          }
          for (let i = 0; i < this.branch.length; i++) {
            columns2[i] = [`${this.branch[i]}`, this.memberB[i]]
          }
          let c3colum1 = []
          let c3colum2 = []
          console.log('this.columns1', columns1)
          console.log('this.columns2', columns2)
          c3colum1 = this.compareAndChangValue(columns1)
          c3colum2 = this.compareAndChangValue(columns2)
          console.log('c3colum1', c3colum1)
          console.log('c3colum2', c3colum2)
          this.chartData2 = {
            data: {
              columns: c3colum2,
              type: 'donut'
            },
            donut: {
              title: 'สาขา'
            }
          }
          this.chartData3 = {
            data: {
              columns: c3colum1,
              type: 'donut'
            },
            donut: {
              title: 'ประเภทบริการ'
            }
          }
          // this.fillData()
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    fillData () {
      this.chartData = {
        labels: this.service,
        datasets: [
          {
            backgroundColor: [
              '#F43B86',
              '#6E85B2',
              '#FF67E7',
              '#C400FF',
              '#3E2C41',
              '#87A8A4'
            ],
            data: this.memberS
          }
        ]
      }
      this.chartData1 = {
        labels: this.branch,
        datasets: [
          {
            backgroundColor: [
              '#F43B86',
              '#6E85B2',
              '#FF67E7',
              '#C400FF',
              '#3E2C41',
              '#87A8A4'
            ],
            data: this.memberB
          }
        ]
      }
    },
    compareAndChangValue (array) {
      let result = []
      array.reduce((prev, cur) => {
        if (!prev[cur[0]]) {
          prev[cur[0]] = [cur[0], cur[1]]
          result.push(prev[cur[0]])
        } else {
          console.log(cur)
          result.forEach((element, key) => {
            if (element[0] === cur[0]) {
              element[1] = cur[1] + element[1]
            }
          })
        }
        return prev
      }, [])
      return result
    }
  }
}
</script>
<style>
  @import '../../assets/c3.min.css';
</style>



// WEBPACK FOOTER //
// src/components/ReportActivity/ChartMemberUseActivity.vue